import React from 'react'
import CustomersHubPage from "./CustomersHubPage"

function CustomersHubContainer() {
    return (
        <div className="CustomersContainer">
            <CustomersHubPage/>
        </div>
    )
}

export default CustomersHubContainer
